var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGrey100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 35,
    viewBox: "0 0 86 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_744_3805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.6175 18.8898L46.2685 23.2388C46.2685 23.2388 46.1439 23.3252 46.0607 23.3396L31.0607 24.7076C31.0607 24.7076 31.0469 24.7076 31.033 24.7076L29.7865 25.1397L28.9278 25.4853L27.4458 26.1765C27.335 26.2341 27.3765 26.4069 27.5012 26.3925L43.72 24.9092C44.0386 24.8804 44.2048 25.2837 43.9832 25.4997L41.1716 28.3078C41.1716 28.3078 41.0607 28.3942 40.9915 28.3942L11.7948 32.5992L9.35715 32.9448L0.395927 34.2409C0.0081149 34.2985 -0.14424 33.7369 0.229722 33.5784L14.0247 27.7318L77.3904 0.528899C77.7366 0.384892 78.0137 0.831313 77.7505 1.10493L62.6397 16.1968L59.8835 18.9474L59.2048 19.6242L56.4624 22.3603L54.925 23.9012L53.263 25.5573L51.961 26.8533L50.4513 28.3654L48.6508 30.1655L45.3544 33.4488C45.3544 33.4488 45.2436 33.5353 45.1605 33.5353L38.0691 34.4857C37.7505 34.5289 37.5704 34.1257 37.792 33.8953L40.576 31.1159L43.6646 28.0342L47.0995 24.6068L48.6231 23.0804L52.8197 18.8898L56.4763 15.2464L58.7062 13.0143C58.7893 12.9279 58.7062 12.7695 58.5815 12.8271L44.4679 18.9474",
    fill: "#E2E2E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.6956 22.0007L53.7482 27.5161C53.6374 27.5305 53.5682 27.4009 53.6513 27.3145L56.6152 24.276C56.6152 24.276 56.7399 24.1896 56.823 24.1752L82.6679 21.7559C82.8064 21.7559 82.8341 21.9575 82.6956 21.9863V22.0007Z",
    fill: "#E2E2E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M84.7178 19.7249L59.4684 22.4034C59.1499 22.4322 58.9698 22.029 59.2053 21.813L62.0031 19.0481C62.0031 19.0481 62.1416 18.9473 62.2385 18.9473L84.6901 19.0337C85.1056 19.0337 85.1471 19.6817 84.7178 19.7249Z",
    fill: "#E2E2E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_3805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 34,
    fill: "white",
    transform: "translate(0.0224609 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey100);
export default __webpack_public_path__ + "static/media/logo-grey-100.6601c842125c1325e909aa793a1fbc2a.svg";
export { ForwardRef as ReactComponent };